module.exports = {
    "clickToEdit": "mcfde158e7_clickToEdit",
    "shortClick": "mcfde158e7_shortClick",
    "select": "mcfde158e7_select",
    "size": "mcfde158e7_size"
};